import supabase from "../config/supabaseConfig";

// Chama a Edge Function alterar-papel. O gate (só admin troca papel, e não o
// próprio) é validado DENTRO da function — aqui só repassa o pedido.
export async function alterarPapel({ userId, novoPapel }) {
  const { data, error } = await supabase.functions.invoke("alterar-papel", {
    body: { user_id: userId, novo_papel: novoPapel },
  });

  if (error) {
    // FunctionsHttpError guarda o Response em error.context — extrai a
    // mensagem pt-BR que a function devolve em { error }.
    let msg = error.message;
    try {
      const body = await error.context?.json();
      if (body?.error) msg = body.error;
    } catch {
      // corpo não-JSON (ex.: gateway) — fica com a mensagem genérica
    }
    throw new Error(msg);
  }

  return data; // { user_id, papel }
}

const alterarPapelService = { alterarPapel };
export default alterarPapelService;
